import { useEffect } from 'react';

/**
 * ページ内アンカーリンクをスムーズスクロールさせるカスタムフック
 * @param offset スクロール位置のオフセット（例：固定ヘッダー分の高さ）
 */

export function useAnchorSmoothScroll(offset: number = 0) {
  useEffect(() => {
    const handler = (e: Event) => {
      const anchor = (e.target as HTMLElement).closest('a');
      if (anchor && anchor instanceof HTMLAnchorElement && anchor.hash && anchor.hash.startsWith('#')) {
        const id = anchor.hash.slice(1);
        const el = document.getElementById(id);
        if (el) {
          e.preventDefault();
          const rect = el.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          window.scrollTo({
            top: rect.top + scrollTop - offset,
            behavior: 'smooth',
          });
        }
      }
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [offset]);
}
